import classNames from 'classnames'
import { ReactElement } from 'react'
import { TailwindConfig } from '../../tailwind-config'
import './fontello/css/fontello.css'

type NameMapChild = {
  name: string
  className?: string
}

// The 62 icons are sorted by the CSS key in config.json; 2022/06/07 updated
export const iconNames: Record<string, string | NameMapChild> = {
  account: 'account',
  add: 'add',
  aifi: 'aifi',
  box: 'box',
  camera: 'camera',
  check: 'check',
  'check-solid': 'check-solid',
  clear: 'clear',
  close: 'close',
  coin: 'coin',
  copy: 'copy',
  'credit-card': 'credit-card',
  desktop: 'desktop',
  'dollar-sign': 'dollar-sign',
  downopen: 'downopen',
  downopenmini: 'downopenmini',
  error: 'error',
  eyes: 'eyes',
  eyesclosed: 'eyesclosed',
  facebook: 'facebook',
  form: 'form',
  have: 'have',
  'have-active': 'have-active',
  home: 'home',
  'home-active': 'home-active',
  icecream: 'icecream',
  infor: 'infor',
  instagram: 'instagram',
  jaja: 'jaja',
  'jaja-active': 'jaja-active',
  leftopen: 'leftopen',
  leftopenmini: 'leftopenmini',
  line: 'line',
  'line-outline': 'line-outline',
  loading: { name: 'loading', className: 'animate-spin inline-block' },
  lock: 'lock',
  'magnifying-glass': 'magnifying-glass',
  mail: 'mail',
  medium: 'medium',
  menu: 'menu',
  messenger: 'messenger',
  'messenger-outline': 'messenger-outline',
  money: 'money',
  more: 'more',
  notification: 'notification',
  pen: 'pen',
  'pig-nose': 'pig-nose',
  recmd: 'recmd',
  'recmd-active': 'recmd-active',
  reflash: 'reflash',
  rightopen: 'rightopen',
  rightopenmini: 'rightopenmini',
  send: 'send',
  share: 'share',
  'share-link': 'share-link',
  shot: 'shot',
  star: 'star',
  time: 'time',
  transfer: 'transfer',
  trashcan: 'trashcan',
  unlock: 'unlock',
  upgrade: 'upgrade',
  upopen: 'upopen',
  upopenmini: 'upopenmini',
  wallet: 'wallet',
  youtube: 'youtube',
} as const

export type IconProps = {
  onClick?: () => void
  name: keyof typeof iconNames
  className?: string
  style?: Record<string, unknown>
  color?: TailwindConfig['colors']
  fontSize?: TailwindConfig['fontSize']
}

function getNameMapValue(name: string) {
  if (typeof iconNames[name] === 'object') {
    const { className } = iconNames[name] as NameMapChild
    if (typeof className === 'string') {
      return 'babu-icon-' + name + ' ' + className
    }
  }
  return 'babu-icon-' + name
}

export default function Icon({
  onClick,
  name,
  className,
  style,
  color,
  fontSize = 'subtitle',
}: IconProps): ReactElement | null {
  if (iconNames[name]) {
    return (
      <i
        className={classNames(
          'm-0',
          getNameMapValue(name),
          className,
          {
            'cursor-pointer': !!onClick,
          },
          `text-${fontSize}`,
          color ? `text-${color}` : undefined,
        )}
        style={style}
        onClick={onClick}
      />
    )
  }
  return null
}
